exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-20 {\n  margin-bottom: 20px; }\n\n.dsb-item {\n  height: 400px;\n  margin-bottom: 40px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/pie-chart/pie-chart.component.scss
// module id = ../../../../../src/app/_custom/pie-chart/pie-chart.component.scss
// module chunks = main